__turbopack_context__.v({
  "filterToggle": "search-results-module__sBL_Zq__filterToggle",
  "groupHead": "search-results-module__sBL_Zq__groupHead",
  "groupName": "search-results-module__sBL_Zq__groupName",
  "groupNote": "search-results-module__sBL_Zq__groupNote",
  "layout": "search-results-module__sBL_Zq__layout",
  "noMatch": "search-results-module__sBL_Zq__noMatch",
  "noMatchBtn": "search-results-module__sBL_Zq__noMatchBtn",
  "noMatchIcon": "search-results-module__sBL_Zq__noMatchIcon",
  "noMatchText": "search-results-module__sBL_Zq__noMatchText",
  "noMatchTitle": "search-results-module__sBL_Zq__noMatchTitle",
  "otherHead": "search-results-module__sBL_Zq__otherHead",
  "otherNote": "search-results-module__sBL_Zq__otherNote",
  "otherTitle": "search-results-module__sBL_Zq__otherTitle",
  "railOpen": "search-results-module__sBL_Zq__railOpen",
  "railWrap": "search-results-module__sBL_Zq__railWrap",
  "results": "search-results-module__sBL_Zq__results",
});
